export type GlobalSetting = {
    id: number
    name: string
    value: boolean | string | number | PHPQuerySetting
    input_type: InputType
}
export type InputType = 'boolean' | 'string' | 'number' | 'PHPQuerySetting'

export type ValueTypeMap = {
    boolean: boolean
    number: number
    int: number
    string: string
    json: Record<string, unknown>
    PHPQuerySetting: PHPQuerySetting
    color: string
    array: unknown[]
}

export enum SettingType {
    BOOLEAN = 'boolean',
    INT = 'int',
    NUMBER = 'number',
    STRING = 'string',
    JSON = 'json',
    PHPQUERYSETTING = 'PHPQuerySetting',
    ARRAY = 'array',
    COLOR = 'color'
}

export type QueryMethod =
    | 'after'
    | 'before'
    | 'prepend'
    | 'append'
    | 'html'

export type PHPQuerySetting = {
    selector: string
    queryMethod: QueryMethod
}

type BaseSetting = {
    id: number;
    name: string;
};

export type Setting =
    | (BaseSetting & {
    input_type: SettingType.BOOLEAN;
    value: boolean;
})
    | (BaseSetting & {
    input_type: SettingType.NUMBER | SettingType.INT;
    value: number;
})
    | (BaseSetting & {
    input_type: SettingType.STRING | SettingType.COLOR;
    value: string;
})
    | (BaseSetting & {
    input_type: SettingType.JSON;
    value: Record<string, unknown>;
})
    | (BaseSetting & {
    input_type: SettingType.PHPQUERYSETTING;
    value: PHPQuerySetting;
});